import { GradProgram as ApiGradProgram } from 'api/gradSchools';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../../actions/gradSchools/gradPrograms';

export type GradProgram = ApiGradProgram & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, GradProgram>;
};
export default function gradPrograms(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.programId]: {
            ...state.byId[action.programId],
            id: action.programId,
            isFetching: true,
          },
        },
      };

    case 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.program.id]: { ...action.program, isFetching: false },
        },
      };

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
